export const sizeOptions = [
  { value: '1:1', label: '1:1', w: 1080, h: 1080 },
  { value: '4:3', label: '4:3', w: 1024, h: 768 },
  { value: '16:9', label: '16:9', w: 1920, h: 1080 },
  { value: '9:16', label: '9:16', w: 1080, h: 1920 },
  { value: 'A4', label: 'A4', w: 2480, h: 3508 },
];

export const styleActions = [
  {
    label: '极简风格',
    icon: '🎨',
    type: 'style',
    url: '',
    match: null,
    prompt: '采用极简主义设计风格，使用大量留白，简洁的线条和单一色调，突出核心内容',
  },
  {
    label: '赛博朋克',
    icon: '🤖',
    type: 'style',
    url: '',
    match: null,
    prompt: '使用赛博朋克风格，霓虹灯效果，紫色和蓝色为主色调，未来科技感十足',
  },
  {
    label: '复古风格',
    icon: '📻',
    type: 'style',
    url: '',
    match: null,
    prompt: '采用复古设计风格，使用怀旧色调和纹理，模仿老式印刷效果',
  },
  {
    label: '3D立体',
    icon: '🖼️',
    type: 'style',
    url: '',
    match: null,
    prompt: '使用3D立体效果，增加深度感和空间感，采用阴影和高光突出立体效果',
  },
  {
    label: '手绘风格',
    icon: '✏️',
    type: 'style',
    url: '',
    match: null,
    prompt: '采用手绘插画风格，使用柔和的色彩和手绘质感，营造温馨亲切的氛围',
  },
  {
    label: '渐变风格',
    icon: '🌈',
    type: 'style',
    url: '',
    match: null,
    prompt: '使用渐变色彩，创造流畅的色彩过渡，营造现代感和活力感',
  },
  {
    label: '孟菲斯风格',
    icon: '🟥',
    type: 'style',
    url: '',
    match: null,
    prompt: '采用孟菲斯设计风格，使用几何图形、大胆色彩和重复图案，充满趣味性',
  },
  {
    label: '霓虹灯效果',
    icon: '💡',
    type: 'style',
    url: '',
    match: null,
    prompt: '使用霓虹灯效果，明亮色彩搭配发光效果，营造夜店或城市夜景氛围',
  },
];

export const actions_zh = [
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/3697e486-105f-4480-95f6-afeb8de28d24_thumbnail.webp?v=2',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
标题：7 种常用的设计小巧思
博主ID：Seede 设计指南
标签：AI 设计干货分享
CTA：提升视觉直觉`,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/cca6798b-5de8-4f5e-8384-e2f475e28682_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `<整体风格>
潮流现代、简约大气，具视觉冲击，酸性设计风格，色号 #5ec26a 。
<背景描述>
白色背景，搭配多个动态模糊绿色椭圆增加层次感

<内容信息>
标签：DIANJI LV TI SHENG
副标题：爆款封面标题
副标题翻译：BAO KUAN FENG MI
突出 10 种爆款封面标题相关内容，强调提升点击率，含中英文对照文字及趣味图案。`,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/7deace37-15b6-41e7-a685-06576e913832_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个小红书封面：
大字报式标题（美颜字体）
标题使用大字体 140px, 其他文字 48 或 36px
标题：✨3个懒人穿搭公式｜被追着问的ootd合集`,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/cda9334d-7070-4586-81c4-52839e066b77_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
标题：越吃越瘦的5种零食
博主ID：Seede 设计指南
标签：AI 吃喝干货分享
CTA：提升味觉直觉`,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/42fcd062-34dd-48d9-9627-6fdbcfdce015_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
标题：5件让房间瞬间高级的小物
博主ID：Aesthete 生活美学
标签：AI 家居改造指南
CTA：提升空间感知力`,
  },

  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/058e7602-950b-4613-8d94-8289f064f564_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
标题：3个通勤路上的碎片学习法
博主ID：EduTech 成长实验室
标签：AI 效率提升干货
CTA：激活你的隐藏时间`,
  },

  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/d4ce27cc-9687-4f38-9876-85e1491cb82a_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
博主ID顶部右侧
标签顶部左侧
CTA 底部右侧
酸性设计风格，背景有动态模糊椭圆
确保文字与背景明度对比度达4.5:1以上
无需配图, 使用中文字体

标题：7 种常用的设计小巧思
博主ID：Seede 设计指南
标签：AI 设计干货分享
CTA：提升视觉直觉 `,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/0664f6dc-2d5c-4450-b105-97aad851790e_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `<整体风格>
潮流现代，简约大气，具视觉冲击，黑橙配色为主色调。
<背景描述>
橙色背景，无其他装饰元素，简洁干净。
<关键视觉元素排版位置及详情>
标签1：顶部左侧，黑色圆形线条，居中黑色字体（36px）。
标签2：顶部右侧，与标签1齐平，黑底按钮，圆角，居中有橙色字体（36px）。
黑色矩形区域：占据较大部分画面，高度1000px，延伸至海报两侧边
主标题：在黑色矩形内顶部区域，宽度等于黑色矩形，单行文本，超大橙色字体（150px）。
产品图1：主标题下方左侧，一张花露水产品图，图片左侧紧靠左边
产品图2：主标题下方右侧，一张迪奥真我香水产品图，图片右侧紧靠右边
产品图tag：橙色按钮，圆角，字体大小（50px）
产品图tag1：在黑色矩形中，产品图1 下方，Y轴中中心与产品图1 对齐
产品图tag1：在黑色矩形中，产品图2 下方，Y轴中心与产品图2 对齐
副标题：黑色矩形下方，左侧较大黑色字体 “AIGC 详细教程”（较大字号），右侧有较小英文 “Everything can be cloud like”。
<内容信息>
标签1 ：NO.1
标签2： Seede教程
主标题：AI 帮你做海报
产品图2tag：东拼西凑
产品图2tag: AI 给出的图
副标题：AIGC 详细教程
英文：Everything can be cloud like`,
  },
  {
    image:
      'https://static.seedeai.com/templates/db7869d9-1398-48da-9a65-92b135a3984d_thumbnail.webp?v=1',
    prompt: `<整体风格>
手绘插画风，温馨治愈、简约柔和，色彩搭配明亮且具亲和力。
<背景描述>
浅米色复古信纸背景
<关键视觉元素排版位置及详情>
主标题 “GODDESS DAY” ：位于顶部，112px，深蓝色加粗字体，清晰醒目。
中文副标题：主标题下方，64px，深蓝色加粗字体，与主标题居中对齐
人物群像：占据画面大部分空间，从上到下、从左到右分布，人物形象多样，体现不同职业，如律师、护士、职员、老师、女强人、职业经理人等，表情愉悦，色彩丰富，以暖色调为主，人物之间有重叠和互动感。
<内容信息>
主标题：GODDESS DAY
副标题：她有多种角色 更有多样绝色
画面主体：多个人物形象，展现女性不同角色和风采`,
  },
  {
    image:
      'https://static.seedeai.com/templates/b8e3caef-9783-4d5b-a6d5-70d3cdc4736b_thumbnail.webp?v=1',
    prompt: `设计一张女神节海报
<整体风格>
油画风，柔和优雅，具温暖治愈感
<背景描述>
背景为水波，水纹荡漾流动，模糊色彩效果，主要呈现粉色与白色交织的渐变，营造出柔和且梦幻的氛围
<关键视觉元素排版位置及详情>
主标题 “HAPPY WOMEN'S DAY”：位于图片上部，距离顶部约 15% 位置，居中排列，左对齐， 105px，黑色，细体字
中文标题 “她.自有光”：位于主标题下方，约距离主标题底部 1/3 图片高度的位置，居中，黑色，细体字（约 120px），颜色为黑色。
副标题 “温柔坚定 照亮前行的每一步”：在中文标题下方，紧挨其后，居中排列，字体更细（约 40px），颜色为黑色。
日期 “2025 03.08”：位于图片底部，距离底部约 10% 位置，居中，字体较小（约 30px），颜色为黑色。
英文内容 “SHE WHO BELIEVES IN HER STRENGTH, SHAPES THE WORLD WITH HER GRACE.”：在日期下方，紧挨日期，居中，字体与日期相同（约 30px），颜色为黑色。
<内容信息>
主标题：HAPPY WOMEN'S DAY
中文标题：她.自有光
副标题：温柔坚定 照亮前行的每一步
日期：2025 03.08
英文内容：SHE WHO BELIEVES IN HER STRENGTH, SHAPES THE WORLD WITH HER GRACE.`,
  },
  {
    image:
      'https://static.seedeai.com/templates/7ae14d1f-1711-48bc-b359-ef3172325ad6_thumbnail.webp?v=1',
    prompt: `主题风格：梦幻童话风格，柔和清新的色彩，以粉色为主，充满梦幻与温暖。
内容大纲：
文字：“女神的礼物”
视觉元素：
背景：单张背景图片（一幅充满梦幻感的3D插画，风格甜蜜、浪漫且充满梦幻童话感。主色调为粉色，营造出温暖而梦幻的氛围。背景为浅蓝色天空，点缀白色和粉色的云朵，画面中有绿色草地小坡、粉色花朵和石头，左右两侧有粉色的桃花树，营造出浪漫的春日氛围，背景中央位置有一个巨大的粉色数字“38”（800像素）。数字“38”下方是一辆粉色有轨电车（1000像素），与数字紧密相连，细节包括车窗和车头灯，仿佛行驶在草地上）。
布局结构：
文字位于屏幕顶部。
色彩与对比：
主色调：粉色、浅蓝色、白色、绿色。
文字颜色为粉色，带有浅色阴影，与背景有足够的对比度，以确保可读性。`,
  },
  {
    label: '社媒图文',
    image:
      'https://static.seedeai.com/templates/a1226e98-595e-4da2-af3b-a38e2bea22d8_thumbnail.webp?v=1',
    icon: '📱',
    tag: 'social-media',
    prompt: `<整体风格>
潮流现代、简约大气，具视觉冲击，酸性设计风格，色号 #5ec26a 。
<背景描述>
白色背景，搭配多个动态模糊绿色椭圆增加层次感

<关键视觉元素排版位置及详情>
动态模糊绿色椭圆：重心位于主标题背后
标签：顶部右侧，纤细字体（20px）
左上角：横向排列小方块图案。
主标题：距离顶部 18% ，靠左，超大黑色粗体 “10”（400px）右侧偏上绿色正圆形,圆形内有居中白色 “种” 字（150px）
副标题：主标题下方，粗字体（144px，不折行）。
副标题翻译：副标题下方，细字体（36px）
网格布局，以上各元素上下有合理间距

<元素>
右下侧：😄 emoji 字符，275px，距离画布边缘有合理边距，呈现俏皮笑脸模样。
左下侧：较粗字体 “让你的点击率提升 10 倍！”，56px，突出 “提升 10 倍” 。

<内容信息>
标签：DIANJI LV TI SHENG
副标题：爆款封面标题
副标题翻译：BAO KUAN FENG MI
突出 10 种爆款封面标题相关内容，强调提升点击率，含中英文对照文字及趣味图案。`,
  },
  {
    image:
      'https://static.seedeai.com/templates/b4659eea-5277-4cc9-9937-b4b4651a553a_thumbnail.webp?v=1',
    prompt: `<整体风格>
简约文艺风，色调柔和，文字排版简洁清晰，富有哲理意味。
<背景描述>
灰色大理石纹理，纹理较少
<关键视觉元素排版位置及详情>
咖啡杯：位于右中部，占据较大空间，呈现出俯视视角的圆形咖啡杯，内有咖啡液体，咖啡杯边缘有阴影效果，增加立体感
主标题：左上角，较大字号白色字体 “Break time”，与背景形成对比，突出主题。
文字内容：主标题下方，较小字号白色字体，内容为关于咖啡与关系的比喻性文字，排版紧凑，富有哲理。
<内容信息>
主标题：Break time
文字内容：Sama seperti kopi, kadang di dalam suatu hubungan ada pahit dan manisnya … Semua tergantung bagaimana menikmatinya -Coffee Time`,
  },
  {
    label: '极简海报',
    icon: '🖼️',
    image:
      'https://static.seedeai.com/templates/780751bd-e8f5-4caa-8244-deccdd39c455_thumbnail.webp?v=2',
    prompt: `设计极简风格品牌活动海报
主标题使用72-96pt无衬线字体展示标题
副标题在右下方使用24-36pt同字体系列展示
背景采用浅灰色（#F5F5F5）留白
左上方叠加一个品红色（#FF006E）的流体渐变抽象形状（占画面40%面积），动态模糊，毛玻璃质感
确保标题组与背景元素间距不小于海报高度的15%。文案需保持左对齐，行距为字号的1.5倍。
右下角放置一个二维码和引导扫描文案

标题：2025 未来科技峰会
副标题：『探索人工智能新纪元』
主办方：全球AI 联合会
地点：模拟数据
时间：模拟数据
二维码：https://seede.ai
`,
  },
  {
    label: '柔和渐变背景图文',
    icon: '🖼️',
    image:
      'https://static.seedeai.com/templates/c080ce2d-1b59-41bf-88c4-236de65043a6_thumbnail.webp?v=2',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
博主ID顶部右侧
标签顶部左侧
CTA 底部右侧
背景：使用图片，柔和渐变背景，采用淡蓝色、浅紫色和粉色的渐变色，整体呈现出梦幻、清新的视觉效果。线条流畅，具有动感和层次感，营造出一种轻盈、优雅的氛围

确保文字与背景明度对比度达4.5:1以上
使用中文字体

标题：7 种常用的设计小巧思
博主ID：Seede 设计指南
标签：AI 设计干货分享
CTA：提升视觉直觉
`,
  },
  {
    label: '一张咖啡师招聘海报',
    image:
      'https://static.seedeai.com/templates/01ada8b1-4411-4ac5-8ca1-cbc4adcfa3c2_thumbnail.webp?v=1',
    prompt: `一张咖啡师招聘海报，背景为抽象艺术风格
bento 卡片风格，正文文字大小 48px/32px，文字与背景之间有50%半透明黑色模糊遮罩确保文字对比度
主体居中，与画布左右有合理间距

标题：咖啡师招聘（120px）
副标题：我们正在寻找充满热情和才华的咖啡师（48px）
职位要求：热爱咖啡文化 具备咖啡制作经验 良好的沟通能力和团队合作精神 积极主动，责任心强
福利待遇：
有竞争力的薪资
完善的培训体系
广阔的晋升空间
联系方式：
hr@coffeeshop.com`,
  },

  {
    label: '传统节气海报立春',
    image:
      'https://static.seedeai.com/templates/142ea5b1-b910-4043-beee-d0dcdb26fd55_thumbnail.webp?v=1',
    prompt: `请帮我一个中国节气的海报
背景层：一个完整的图片（体现节气氛围，图片中不要出现文字，浅色系）
文字层：
标题（颜色#c08340，大小：260px）、小标题，使用中文字体
确保文字与背景有合理的颜色对比度
节气：立春`,
  },
  {
    label: '惊蛰传统节气海报',
    image:
      'https://static.seedeai.com/templates/659606b3-00e8-4134-a569-2168ce9ddb99_thumbnail.webp?v=2',
    prompt: `请帮我一个中国节气的海报
背景层：一个完整的图片（体现节气氛围，图片中不要出现文字，浅色系）
文字层：
标题（颜色#c08340，大小：260px）、小标题，使用中文字体
确保文字与背景有合理的颜色对比度
节气：惊蛰`,
  },
  {
    label: '播客海报',
    image:
      'https://static.seedeai.com/templates/4fccc6df-9665-4a55-b85d-fc873005b34c_thumbnail.webp?v=1',
    icon: '📰',
    prompt: '以苹果网站风格设计一个AI公司播客海报',
  },

  {
    label: '视频封面',
    image:
      'https://static.seedeai.com/templates/c392c0c8-565e-47d4-87e1-08ffe2169169_thumbnail.webp?v=4',
    icon: '🎬',
    prompt:
      '设计一个简约 Notion 风格的视频封面海报\n标题：如何打造一个 AI 设计工具\n产品名： Seede AI',
  },
  {
    label: '单词闪卡',
    image:
      'https://static.seedeai.com/templates/2afce34d-6c69-45aa-8148-0af15b5d32bc_thumbnail.webp?v=1',
    icon: '📇',
    prompt: `设计一个单词卡片：中央区域（70%）以120-150磅的粗体字体显示“Apple”一词。在标题上方的合适位置，添加一张高质量的、风格化的苹果图像（例如，极简主义插画、光泽感的3D渲染图或超现实主义的诠释）。在单词上方是一个36磅的灰色音标符号，下方是48磅的中文释义。卡片底部的20%区域以24磅的字体显示双语例句。背景采用鲜艳的渐变色，以确保文字与背景之间的亮度对比度至少为4.5:1。设计风格为酸性风格，背景中有动态模糊的椭圆和几何图形，营造出现代且前卫的美感。确保图像与整体设计相得益彰，而不压过文字。`,
  },

  {
    label: '新闻简报',
    image:
      'https://static.seedeai.com/templates/9fa38c10-8148-446f-bd85-b12d039b1cf2_thumbnail.webp?v=1',
    icon: '📢',
    prompt: `生成一个简洁的新闻简报图文，设计参考 Apple 网站风格
左上角展示产品名称和 logo
产品：Reader.news
顶部30% 区域匹配一个新闻配图
这个是一个用于社交媒体的图文，标题使用54px，其他文字使用26 or 32px

新闻内容：
顶级域名 ai.com 跳转至 DeepSeek，此前曾跳至 ChatGPT
周一
近期，ai.com 域名被误传为 DeepSeek 收购，实际上该域名曾跳转至 ChatGPT 和马斯克的 xAI 项目。域名跳转功能导致误解，域名所有者可设置跳转地址，访问者看到的页面不一定与域名所有者直接相关。ai.com 域名于 1993 年注册，有效期至 2031 年，注册人信息隐藏，但域名跳转行为引发对互联网资产管理和域名价值的思考。

相关报道
顶级域名定向到 DeepSeek 官网！背后持有人神秘莫测，此前曾跳转 ChatGPT - XX科技
AI 进化速递 | DeepSeek 获顶级域名 ai.com 认可 - XX财经
ai.com 域名现已跳转至 DeepSeek - XX新闻网`,
  },

  {
    image:
      'https://static.seedeai.com/templates/62d5347e-b202-4146-a929-16bfcbd9797c_thumbnail.webp?v=1',
    prompt: `<整体风格>
简约现代、时尚大气，具艺术感，以展示产品为主
<背景描述>
上半部分为浅灰色，下半部分为黑色，形成斜角上下分层科技风格渐变背景效果
<关键视觉元素排版位置及详情>
标题 “furniture”：位于顶部左侧，较小字号（约 20px），常规黑色字体。
主标题 “Lounge chair”：距离顶部约 20% ，居左排列，较大黑色加粗字体（约 100px），下方紧跟着 “休闲椅” 三个字，字体稍小且为常规字体。
休闲椅图片：位于右下部分，占据画面较大部分空间，椅子为蓝色，有红色绑带，呈现独特的造型。
“Customiz” 手写体：在休闲椅图片右上方，红色字体，倾斜排列，与椅子图片相互呼应。
<内容信息>
底部有一行小字，内容为 “Home is not just a living space, but also a work of art that contains stories and inspiration.” ，字体较小，颜色较浅，位于黑色背景区域，距离底部边缘有一定间距。`,
  },

  {
    image:
      'https://static.seedeai.com/templates/d1ebf1ae-e0f7-4d70-907c-620551167c8b_thumbnail.webp?v=1',
    tag: 'social-media',
    prompt: `设计一个简约 Notion 风格的视频封面海报
标题：如何打造一个 AI 设计工具
产品名： Seede AI

背景图：设计风格简约现代，几何线条，浅蓝色调，层次感强，立体圆形基座，背景有弧形和直线元素，整体清新优雅。`,
  },
  {
    image:
      'https://static.seedeai.com/templates/1aae6a81-3286-495f-b04a-48d0037449e7_thumbnail.webp?v=1',
    tag: 'social-media',
    prompt: `一个简单的小红书图文
标题使用大字体 140px, 其他文字 48 或 36px
博主ID顶部右侧
标签顶部左侧
CTA 底部右侧
确保文字与背景明度对比度达4.5:1以上
无需配图, 使用中文字体
背景图: 设计风格简约现代，几何线条，浅蓝色调，层次感强，立体圆形基座，背景有弧形和直线元素，整体清新优雅。

标题：7 种常用的设计小巧思
博主ID：Seede 设计指南
标签：AI 设计干货分享
CTA：提升视觉直觉 `,
  },
  {
    image:
      'https://static.seedeai.com/templates/e7b6782c-fc48-41f3-b6f1-41391f8a4f70_thumbnail.webp?v=2',
    prompt: `以苹果网站风格设计一个AI公司播客海报
背景：图片，科技感十足，以蓝色调为主，呈现出现代都市的高楼大厦，线条简洁流畅，画面具有层次感和立体感，搭配圆形的光效平台，整体风格简洁大气且富有未来感。`,
  },
  {
    image:
      'https://static.seedeai.com/templates/a480a551-279a-468d-9bfa-31f92a44f8ec_thumbnail.webp?v=1',
    prompt: `<整体风格>
潮流现代、简约大气，具视觉冲击
<背景描述>
背景图：3D魔方感
风格特点 ：抽象几何、未来科技感强，整体呈现出一种梦幻且精致的视觉效果。
色彩运用 ：以蓝色系为主，搭配透明质感和渐变效果，营造出清新、通透的氛围。
元素构成 ：由多个大小不一、形态各异的立方体组合而成，立方体表面有光泽和反光效果，部分立方体有连接结构，整体布局错落有致，富有层次感和空间感。
光影效果 ：光影柔和，通过光线的折射和反射，增强了立方体的立体感和透明感，使画面更具生动性和动态感。

主题： AI 科技公司的产品发布
请按照主题帮我补充详细的内容信息`,
  },
  {
    image:
      'https://static.seedeai.com/templates/58c1d5ae-f5f2-4eb2-81c9-0b2e8357226f_thumbnail.webp?v=2',
    prompt: `<整体风格>
新中式风格，禅意简约、古朴典雅，具东方韵味，强调留白与意境营造
<背景描述>
上半部分为浅灰复古纸张背景，占比60%；下半部分为黑灰白向下渐变色，占比40%；画布正中间一个圆形，橙灰渐变色，整体营造一种宁静祥和的气氛
<关键视觉元素排版位置及详情>
标签1：右上角，竖排， “南山记/” 及拼音，字体纤细， 36px
标签2：左上角，竖排，”瓷为器 匠于心“
主标题：画布上方中间，竖排，“茶里” ，黑色毛笔字风格，笔触粗犷，256px
茶具：位于画布正中，黑色中式茶杯，倒影清晰，体现质感
副标题1：“器”，底部左侧，字号、字体与主标题相同，256px
副标题1：“物”，底部右侧，字号、字体与主标题相同，256px
<内容信息>
底部：底部居中 “禅风
黑石盖碗系列
ARTMAN © DESIGN
鹿竹 / 正道” 等信息，字体较粗（约 50 - 80px），白色，与上方元素保持适当间距，整体布局均衡`,
  },
  {
    image:
      'https://static.seedeai.com/templates/83951046-3b6b-41b7-9231-1ff3d1878591_thumbnail.webp?v=1',
    prompt: `<整体风格>
自然简约、清新淡雅，具有文艺气息，绿色为主色调。
<背景描述>
墨绿色背景，营造自然氛围
<关键视觉元素排版位置及详情>
圆角矩形：位于画布正中心，800*1300，10°圆角分为上下两部分，上半部分占70%，为绿色叶子图案，模糊效果；下半部分为白色，占比30%
标题：圆角矩形右侧上部，较大白色字体（约 40px），右对齐
正文：标题下方，右对齐，较小白色字体（约 20px），右对齐，分段排布，阐述绿色叶子与天气关系
图片：圆角矩形左下方，茂盛的绿色叶子特写图，300*700，大小适中
小文案：位于白色区域内，特写图右侧，较小字体（18px），墨绿色
<内容信息>
标题：Daily Instagram Stories Green is Good
正文：During the day before it rains, the weather conditions are cloudy, that's where the green leaves always make your eyes pampered
小文案：03, January 2023
Archive by doubleli.`,
  },
  {
    image:
      'https://static.seedeai.com/templates/0d3d244f-0904-4be7-962e-9941e01b08f0_thumbnail.webp?v=1',
    prompt: `**标题：**  
时光研磨，醇香留驻  

**副标题：**  
复古咖啡，唤醒记忆中的味道  

**CTA：**  
来一杯时光，品味经典  
📍 [咖啡店地址]  
⏰ 营业时间：每天 8:00 - 20:00  

**背景图：**  
复古色调（深棕、暖黄、墨绿），老式咖啡机、手写菜单、怀旧唱片、木质桌椅`,
  },
];

export const actions = [
  {
    label: 'Minimalist Poster',
    icon: '🖼️',
    image:
      'https://static.seedeai.com/templates/780751bd-e8f5-4caa-8244-deccdd39c455_thumbnail.webp?v=2',
    prompt: `Design a minimalist brand event poster
      Main title in 72-96pt sans-serif font
      Subtitle in bottom right using 24-36pt from same font family
      Light gray (#F5F5F5) background
      Magenta (#FF006E) fluid gradient abstract shape in top left (40% of canvas)
      Maintain 15% of poster height spacing between title group and background elements. Text should be left-aligned with 1.5x line height.
      
      Title: 2025 Future Tech Summit
      Subtitle: "Exploring the New Era of AI"
      Organizer: Global AI Alliance
      Location: Sample Data
      Time: Sample Data
      `,
  },
  {
    label: 'Social Media Post',
    image:
      'https://static.seedeai.com/templates/d4ce27cc-9687-4f38-9876-85e1491cb82a_thumbnail.webp?v=1',
    icon: '📱',
    prompt: `A simple social media post design
Title in large 140pt font, other text 36pt
Creator ID in top right
Tags in top left
CTA in bottom right
Acid design style with dynamic blurred ovals
Ensure text-background contrast ratio above 4.5:1
No image needed

Title: 7 Common Design Tips
Creator ID: Seede Design Guide
Tags: AI Design Tips
CTA: Enhance Visual Intuition`,
  },
  {
    label: 'Social Media Post',
    image:
      'https://static.seedeai.com/templates/0664f6dc-2d5c-4450-b105-97aad851790e_thumbnail.webp?v=1',
    icon: '📱',
    prompt: `<Overall Style>
Modern trendy, simple and elegant, with visual impact, black and orange as main color scheme.
<Background Description>
Orange background, no other decorative elements, clean and simple.
<Key Visual Elements Layout and Details>
Tag 1: Top left, black circular lines, centered black text (36px).
Tag 2: Top right, aligned with Tag 1, black button background, rounded corners, centered orange text (36px).
Black rectangular area: Occupies large portion of canvas, height 1000px, extends to poster sides
Main title: At top of black rectangle area, width equals black rectangle, single line text, extra large orange font (150px).
Product image 1: Left side below main title, one Florida Water product image, image left edge aligned with left border
Product image 2: Right side below main title, one Dior J'adore perfume product image, image right edge aligned with right border
Product image tags: Orange buttons, rounded corners, font size (50px)
Product image tag 1: In black rectangle, below product image 1, Y-axis center aligned with product image 1
Product image tag 2: In black rectangle, below product image 2, Y-axis center aligned with product image 2
Subtitle: Below black rectangle, large black text "AIGC Tutorial" on left (larger font size), smaller English text "Everything can be cloud like" on right.
<Content Information>
Tag 1: NO.1
Tag 2: Seede Tutorial
Main title: AI Helps You Make Posters
Product image 1 tag: Pieced Together
Product image 2 tag: AI Generated Image
Subtitle: AIGC Tutorial
English: Everything can be cloud like`,
  },
  {
    label: 'Social Media Post',
    image:
      'https://static.seedeai.com/templates/a1226e98-595e-4da2-af3b-a38e2bea22d8_thumbnail.webp?v=1',
    icon: '📱',
    prompt: `<Overall Style>
Modern trendy, simple and elegant, with visual impact, acid design style, color #5ec26a.
<Background Description>
White background, complemented with multiple dynamic blurred green ovals for layered effect

<Key Visual Elements Layout and Details>
Dynamic blurred green ovals: Centered behind main title
Tag: Top right, thin font (20px)
Top left: Horizontally arranged small square patterns.
Main title: 18% from top, left-aligned, extra large black bold "10" (400px) with green circle on right upper side, centered white character "Types" (150px) inside circle
Subtitle: Below main title, bold font (144px, no line break).
Subtitle translation: Below subtitle, thin font (36px)
Grid layout, with reasonable spacing between all above elements

<Elements>
Bottom right: 😄 emoji character, 275px, reasonable margin from canvas edge, showing playful smiling face.
Bottom left: Bold font "Increase your click-through rate by 10 times!", 56px, emphasizing "increase 10 times".

<Content Information>
Tag: CLICK RATE INCREASE
Subtitle: Viral Cover Titles
Subtitle translation: VIRAL COVER
Emphasize 10 types of viral cover titles content, highlighting increased click-through rate, including Chinese-English bilingual text and fun graphics.`,
  },

  {
    image:
      'https://static.seedeai.com/templates/b4659eea-5277-4cc9-9937-b4b4651a553a_thumbnail.webp?v=1',
    prompt: `<Overall Style>
Minimalist artistic style, soft color tones, clean and clear text layout, with philosophical meaning.
<Background Description>
Gray marble texture, minimal pattern
<Key Visual Elements Layout and Details>
Coffee cup: Located in the right middle area, occupying large space, showing a top-down view of a round coffee cup containing coffee liquid, with shadow effects on cup edges to enhance dimensionality
Main title: Top left corner, large white font "Break time", contrasting with background to emphasize theme.
Text content: Below main title, smaller white font, containing metaphorical text about coffee and relationships, compact layout with philosophical meaning.
<Content Information>
Main title: Break time
Text content: Just like coffee, sometimes in a relationship there are bitter and sweet moments... It all depends on how you enjoy it -Coffee Time`,
  },
  {
    label: 'Vocabulary Flashcard',
    image:
      'https://static.seedeai.com/templates/2afce34d-6c69-45aa-8148-0af15b5d32bc_thumbnail.webp?v=1',
    icon: '📇',
    prompt: `Design a vocabulary card: Central area (70%) displays "Apple" in 120-150pt bold font. Above the title, place a high-quality stylized apple image (e.g., minimalist illustration, glossy 3D render, or surrealist interpretation). Show gray phonetic symbols in 36pt above the word, with 48pt Chinese translation below. Bottom 20% shows bilingual example sentences in 24pt. Use vibrant gradients ensuring 4.5:1 text-background contrast. Acid design style with dynamic blurred ovals and geometric shapes for modern, avant-garde aesthetics. Ensure image complements without overwhelming text.`,
  },
  {
    label: 'Podcast Poster',
    image:
      'https://static.seedeai.com/templates/4fccc6df-9665-4a55-b85d-fc873005b34c_thumbnail.webp?v=1',
    icon: '📰',
    prompt: 'Design an AI company podcast poster in Apple website style',
  },
  {
    label: 'Video Thumbnail',
    image:
      'https://static.seedeai.com/templates/c392c0c8-565e-47d4-87e1-08ffe2169169_thumbnail.webp?v=4',
    icon: '🎬',
    prompt:
      'Design a minimalist Notion-style video cover poster\nTitle: How to Build an AI Design Tool\nProduct Name: Seede AI',
  },
  {
    image:
      'https://static.seedeai.com/templates/a188273e-0452-46db-804a-384d2664c3b4_thumbnail.webp?v=1',
    prompt:
      'Design a poster for Destination Wedding Venues Virtual Tour  on September 15, 2025, an online event from 1 PM to 5 PM. Use  turquoise and coral colors with a flatdesign style .',
  },
  {
    image:
      'https://static.seedeai.com/templates/64789989-3412-4dd5-bcb6-8bb2914a5af4_thumbnail.webp?v=2',
    prompt:
      'Design a poster for the Vintage-Inspired Wedding Floral Arrangements Show on November 22, 2025, at The Enchanted Garden, 123 Memory Lane, from 10 AM to 2 PM. Mention free entry and complimentary tea service. Use muted pastel colors and a collage style.',
  },

  {
    image:
      'https://static.seedeai.com/templates/e7b6782c-fc48-41f3-b6f1-41391f8a4f70_thumbnail.webp?v=2',
    prompt: `Design an AI company podcast poster in Apple website style
Background: Image with strong tech feel, predominantly blue tones, featuring modern city skyscrapers, clean flowing lines, layered and dimensional composition, complemented with circular light effect platforms, overall style clean and elegant with futuristic appeal.`,
  },
  {
    image:
      'https://static.seedeai.com/templates/ca27705b-a755-40b6-88c7-34bef731d807_thumbnail.webp?v=2',
    prompt: `Theme Style: Futuristic, Technological

Content Outline:
  - Title: Electronics & Technology Exhibition
  - Subtitle: Explore the Future of Technology
  - Body Text: (Leave blank for AI to auto-generate short, relevant text)
  - CTA: Register Now

Visual Elements:
  - Background: Dark blue to purple gradient, subtle circuit board patterns overlaid, glowing neon lines.
  - Foreground Elements: Abstract representations of electronic components (chips, circuits), holographic effects.  Avoid realistic images of devices (phones, laptops) unless absolutely necessary.
  - Font: Modern, clean sans-serif font. Title: large and bold, around 120-150px. Subtitle: slightly smaller, around 60-80px. CTA: prominent and easily readable.

Layout Structure:
  - Title at the top, centered.
  - Subtitle below the title, centered.
  - Body text (generated) placed below the subtitle, aligned to center or justified, keeping it concise.
  - CTA at the bottom, centered and visually distinct (e.g., button-like appearance).

Color and Contrast:
  - High contrast between text and background (e.g., white or light cyan text on dark blue/purple background). Ensure text-to-background contrast ratio exceeds 4.5:1 for accessibility.
  - Color scheme: Predominantly blues, purples, and teals with accents of neon cyan or yellow.

Font Size:
  - Title: 120-150px
  - Subtitle: 60-80px
  - CTA: Sufficiently large and prominent.

use Language: English
`,
  },
  {
    image:
      'https://static.seedeai.com/templates/654c35d5-d968-4848-9a8d-4d12afadd324_thumbnail.webp?v=1',
    prompt: `Theme Style: Whimsical and Playful

Content Outline:
  - Title: It's a Boy!
  - Subtitle: Join us to celebrate the arrival of Jack
  - Body: You're invited to a baby shower honoring Jack!
  - Details: [Date], [Time], [Location], RSVP by [Date] to [Phone number or email address]
  - Special Request: Diapers and wipes are greatly appreciated!

Visual Elements:
  - Background: Soft pastel blue gradient with subtle cloud or star patterns. Consider a gentle bokeh effect for added depth.
  - Foreground Elements: Cute cartoon illustrations of baby-related items such as rattles, pacifiers, teddy bears, or building blocks. A small illustration of a baby stork carrying a bundle would also be fitting.
  - Font: A friendly, rounded sans-serif font. Title: 72px, Subtitle: 48px, Body: 36px, Details: 30px. Use a handwritten-style font for "Jack".

Layout Structure:
  - Title centered at the top, "Jack" prominently featured.
  - Subtitle directly below the title.
  - Body text and Details arranged neatly below the subtitle.
  - Illustrations placed around the text to create a visually appealing and balanced composition.

Color and Contrast:
  - Main color scheme: Primarily pastel blues, whites, and light grays.
  - Accent colors: Soft yellows, greens, or light browns for the illustrations.
  - Text-to-background contrast > 4.5:1. Ensure all text is easily readable against the background.

Foreground Image Necessity: No photograph of the baby is necessary. Rely on illustrations for visual appeal.

Font Size: Emphasize "It's a Boy!" and "Jack" with large, easily readable fonts.

Language: English
`,
  },

  {
    label: 'News Brief',
    image:
      'https://static.seedeai.com/templates/9fa38c10-8148-446f-bd85-b12d039b1cf2_thumbnail.webp?v=1',
    icon: '📢',
    prompt: `Generate a clean news brief design in Apple website style
Product name and logo in top left
Product: Reader.news
News image in top 30% area
Social media format with 54px title, other text in 26 or 32px

News Content:
Domain ai.com Redirects to DeepSeek, Previously Pointed to ChatGPT
Monday
Recently, ai.com was mistakenly reported as acquired by DeepSeek, though it previously redirected to ChatGPT and Musk's xAI project. Domain redirects can be misleading, as owners can set redirect destinations without direct ownership relations. Registered in 1993 with validity until 2031, ai.com's owner remains private, but the redirect raises questions about internet asset management and domain value.

Related Coverage:
Premium Domain Points to DeepSeek Website! Mysterious Owner Previously Redirected to ChatGPT - XX Tech
AI Evolution Express | DeepSeek Gains Recognition from Premium ai.com Domain - XX Finance
ai.com Now Redirects to DeepSeek - XX News`,
  },
  {
    image:
      'https://static.seedeai.com/templates/83951046-3b6b-41b7-9231-1ff3d1878591_thumbnail.webp?v=1',
    prompt: `<Overall Style>
Natural minimalist, fresh and elegant, with artistic flair, green as main color scheme.
<Background Description>
Dark green background, creating natural atmosphere
<Key Visual Elements Layout and Details>
Rounded Rectangle: Located at canvas center, 800*1300, 10° rounded corners divided into two parts, top 70% with blurred green leaf pattern; bottom 30% in white
Title: Upper right side of rounded rectangle, large white font (around 40px), right-aligned
Body Text: Below title, right-aligned, smaller white font (around 20px), right-aligned, paragraphed layout, describing relationship between green leaves and weather
Image: Bottom left of rounded rectangle, lush green leaf close-up, 300*700, moderate size
Caption: Inside white area, right side of close-up image, small font (18px), dark green
<Content Information>
Title: Daily Instagram Stories Green is Good
Body Text: During the day before it rains, the weather conditions are cloudy, that's where the green leaves always make your eyes pampered
Caption: 03, January 2023
Archive by doubleli.`,
  },
];

const presetActions = {
  zh: actions_zh,
  'zh-cn': actions_zh,
  'zh-tw': actions_zh,
  en: actions,
};

export function getPresetActions(locale) {
  locale = (locale || '').toLowerCase();
  return presetActions[locale] || presetActions.en;
}
